var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreySuccessDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0ZM11.358 5.646C11.2752 5.56358 11.1662 5.51275 11.0498 5.50234C10.9334 5.49192 10.8171 5.52259 10.721 5.589L10.651 5.646L7 9.298L5.354 7.651L5.284 7.593C5.18769 7.52665 5.07116 7.49616 4.95469 7.50684C4.83822 7.51752 4.72918 7.56869 4.64653 7.65145C4.56389 7.73421 4.51288 7.84333 4.50237 7.95981C4.49185 8.0763 4.52251 8.19278 4.589 8.289L4.646 8.359L6.646 10.359L6.716 10.416C6.7995 10.4736 6.89855 10.5045 7 10.5045C7.10145 10.5045 7.2005 10.4736 7.284 10.416L7.354 10.358L11.358 6.354L11.416 6.284C11.4826 6.18769 11.5132 6.07108 11.5026 5.95449C11.492 5.8379 11.4408 5.72873 11.358 5.646Z",
    fill: "#D5D8DD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreySuccessDot);
export default __webpack_public_path__ + "static/media/grey_success_dot.dda94dd43755877fe2a221395ce9cda9.svg";
export { ForwardRef as ReactComponent };